export default class UserModel {
  Id: number;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  ImageUrl: string;
  AvatarColor: string;
  constructor(obj?: Partial<UserModel>) {
    Object.assign(this, obj);
  }
}
